/* eslint-disable i18next/no-literal-string */
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import useIntegrationInboundDocsPage from 'pages/IntegrationPage/hooks/useIntegrationInboundDocsPage';
import {
  getRouteSellerIntegrationsSellerConfigPage,
  getRouteSellerIntegrationsSellerReqsPage,
} from 'shared/constants/routerConst';
import { SwaggerDisplay } from 'shared/ui/SwaggerDisplay';

export const IntegrationInboundDocsPage = memo(() => {
  const { sellerId, isLoading, inboundSwagger } =
    useIntegrationInboundDocsPage();

  const sellerConfigLink =
    getRouteSellerIntegrationsSellerConfigPage(sellerId) + '#re-ops-api';
  const sellerReqsLink =
    getRouteSellerIntegrationsSellerReqsPage(sellerId) +
    '#re-ops-api-authentication';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        maxWidth: '1460px',
      }}
    >
      <Typography component="h2" typography="openSans.h2">
        {'RE-OPS API Documentation'}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginBottom: '20px',
        }}
      >
        <Typography>
          This Swagger outlines the endpoints available in the RE-OPS API that
          you will be integrating with.
        </Typography>
        <Typography>
          RE-OPS supports the OAuth 2.0 Client Credentials flow for
          authenticating with the RE-OPS API (documented{' '}
          <Link to={sellerReqsLink}>here</Link> and configured{' '}
          <Link to={sellerConfigLink}>here</Link>).
        </Typography>
        <Divider sx={{ margin: '20px 0' }} />
      </Box>
      <Typography
        component="h2"
        typography="openSans.h2"
        sx={{ marginBottom: '0' }}
      >
        {'RE-OPS API Swagger Specifications'}
      </Typography>
      <SwaggerDisplay swaggerJson={inboundSwagger} isLoading={isLoading} />
    </Box>
  );
});
